import React from 'react'
import { useSelector, shallowEqual } from 'react-redux'

const useSelectedKeys = () => {
  return useSelector(({components}) => components.selected || [], shallowEqual)
}

export default useSelectedKeys
